import { Component, input, output, signal, computed } from '@angular/core';
import { NewsImageComponent, ImagePreview } from '../news-image/news-image.component';

@Component({
  selector: 'app-news-image-list',
  imports: [NewsImageComponent],
  templateUrl: './news-image-list.component.html',
  styleUrl: './news-image-list.component.css'
})
export class NewsImageListComponent {
  readonly previews = input.required<ImagePreview[]>();
  readonly remove = output<number>();
  readonly reorder = output<{ from: number; to: number }>();

  private readonly draggedIndex = signal<number | null>(null);
  private readonly dragOverIndex = signal<number | null>(null);

  protected getItemClasses(index: number): string {
    if (this.draggedIndex() === index) {
      return 'scale-95 opacity-50';
    }
    if (this.dragOverIndex() === index && this.draggedIndex() !== index) {
      return 'scale-105 ring-2 ring-blue-400 shadow-lg';
    }
    return '';
  }

  // Computed signal to determine if an item is being dragged
  protected isDragging = computed(() => this.draggedIndex() !== null);

  // Check if specific index is being dragged
  protected isItemDragging(index: number): boolean {
    return this.draggedIndex() === index;
  }

  // Check if dragging over specific index
  protected isItemDragOver(index: number): boolean {
    return this.dragOverIndex() === index && this.draggedIndex() !== index;
  }

  protected onDragStart(event: DragEvent, index: number): void {
    event.dataTransfer!.effectAllowed = 'move';
    this.draggedIndex.set(index);
  }

  protected onDragEnd(): void {
    this.draggedIndex.set(null);
    this.dragOverIndex.set(null);
  }

  protected onDragOver(event: DragEvent, index: number): void {
    event.preventDefault();
    event.dataTransfer!.dropEffect = 'move';
    
    const draggedIdx = this.draggedIndex();
    if (draggedIdx === null || draggedIdx === index) return;

    this.dragOverIndex.set(index);
    this.reorder.emit({ from: draggedIdx, to: index });
    this.draggedIndex.set(index);
  }

  protected onDragLeave(): void {
    this.dragOverIndex.set(null);
  }

  protected onDrop(event: DragEvent): void {
    event.preventDefault();
    this.draggedIndex.set(null);
    this.dragOverIndex.set(null);
  }

  protected onRemove(index: number): void {
    this.remove.emit(index);
  }
}
